// extracted by mini-css-extract-plugin
module.exports = {"root":"KeyBox_root__1Cy6Z","num":"KeyBox_num__31d3u","cursor":"KeyBox_cursor__39I-x"};